import { docodeHexResponse } from '../../_common/common.utils';
import PromiseToPayReportActionTypes from './promise-to-pay-report.type';

const INITIAL_STATE = {
	getPromisetoPayReportResp: null,
	getPromisetoPayReportArr: [],

	fetchGroupLoanOfficerResp: null,
	fetchGroupLoanOfficerArr: [],

	getPromiseToPayExcelListResp: null,
	getPromiseToPayExcelListArr: [],
};

const paymentToPayReportReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/***************** GET PROMISE TO PAY REPORT START ************* */
		case PromiseToPayReportActionTypes.GET_PROMISE_TO_PAY_REPORT_LIST_SUCCESS:
			return {
				...state,
				getPromisetoPayReportResp: action.payload,
				getPromisetoPayReportArr: docodeHexResponse(
					action.payload,
					'GetPromiseToPayReportListKey',
				),
			};

		case PromiseToPayReportActionTypes.GET_PROMISE_TO_PAY_REPORT_LIST_FAILURE:
			return {
				...state,
				getPromisetoPayReportResp: action.payload,
				getPromisetoPayReportArr: [],
			};

		case PromiseToPayReportActionTypes.GET_PROMISE_TO_PAY_REPORT_LIST_RESPONSE_CHANGED:
			return { ...state, getPromisetoPayReportResp: null };
		/***************** GET PROMISE TO PAY REPORT END ************* */

		/******* START FETCH GROUP LOAN OFFICER LIST ***********/
		case PromiseToPayReportActionTypes.FETCH_GROUP_LOAN_OFFICER_LIST_SUCCESS:
			return {
				...state,
				fetchGroupLoanOfficerResp: action.payload,
				fetchGroupLoanOfficerArr: docodeHexResponse(
					action.payload,
					'GroupLoanOfficerListKey',
				),
			};

		case PromiseToPayReportActionTypes.FETCH_GROUP_LOAN_OFFICER_LIST_FAILURE:
			return {
				...state,
				fetchGroupLoanOfficerResp: action.payload,
				fetchGroupLoanOfficerArr: [],
			};

		case PromiseToPayReportActionTypes.FETCH_GROUP_LOAN_OFFICER_LIST_RESPONSE_CHANGED:
			return { ...state, fetchGroupLoanOfficerResp: null };
		/******* END FETCH GROUP LOAN OFFICER LIST ***********/

		/******************* GET PROMISE TO PAY REPORT EXCEL START *********************** */
		case PromiseToPayReportActionTypes.GET_PROMISE_TO_PAY_EXCEL_SUCCESS:
			return {
				...state,
				getPromiseToPayExcelListResp: action.payload,
				getPromiseToPayExcelListArr: docodeHexResponse(
					action.payload,
					'GetPromiseToPayReportExcelListKey',
				),
			};

		case PromiseToPayReportActionTypes.GET_PROMISE_TO_PAY_EXCEL_FAILURE:
			return {
				...state,
				getPromiseToPayExcelListResp: action.payload,
				getPromiseToPayExcelListArr: [],
			};

		case PromiseToPayReportActionTypes.GET_PROMISE_TO_PAY_EXCEL_RESPONSE_CHANGED:
			return { ...state, getPromiseToPayExcelListResp: null };
		/******************* GET PROMISE TO PAY REPORT EXCEL END *********************** */
		default:
			return state;
	}
};
export default paymentToPayReportReducer;
